export const getRedeemPercentage = (values: {max:number, value: number, min?: number}):string => {
  if (values.value === 0) return '0%';
  const percent = Math.floor(((values.value - (values.min ?? 0)) / (values.max - (values.min ?? 0))) * 100);

  return `${percent}%`;
};
